import React, { createContext, FC, ReactNode, useContext, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { AnalyticsModel } from 'models/analytics';
import { selectCurrentUser } from 'store/User';

interface IProps {
  children: ReactNode;
}

const AnalyticsContext = createContext<AnalyticsModel | null>(null);

export const useAnalytics = () => useContext(AnalyticsContext);

export const AnalyticsProvider: FC<IProps> = ({ children }) => {
  const user = useSelector(selectCurrentUser());
  const analytics = useRef(new AnalyticsModel()).current;

  useEffect(() => {
    analytics.init();
  }, []);

  useEffect(() => {
    if (!user?.id) return;
    analytics.setUserId(user.id);
  }, [user]);

  return <AnalyticsContext.Provider value={analytics}>{children}</AnalyticsContext.Provider>;
};
